<button #trigger (click)="openMenu($event)">
    <img src="/assets/images/grid/menuPoint.svg"></button>
<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayOpen]="true" cdkConnectedOverlayBackdropClass="backdrop-selection"
    (backdropClick)="isMenuOpen=false" [cdkConnectedOverlayOpen]="isMenuOpen"
    [cdkConnectedOverlayPositions]="positonArea">
    <div class="overlay-warp">
            <div class="item" (click)="edit()" *ngIf="distributionGroup?.isActive" >
                <img src="/assets/images/grid/menu/edit.svg">
                <p translate>grid.menu.edit</p>
            </div>
            <div class="item" (click)="changeStatus()">
                <que-toggle [toggleState]="!isDisplayNotActiveItems$()" 
                ></que-toggle>
                <p *ngIf="!isDisplayNotActiveItems$()" translate>grid.menu.changeStatusToNotActive</p>
                <p *ngIf="isDisplayNotActiveItems$()" translate>grid.menu.changeStatusToActive</p>
            </div>
        </div>
</ng-template>